import type { PropsWithChildren } from "react";

import { Flex, Text } from "@similarweb/ui-components/foundations";

import { abbrNumberFilter } from "app/filters/ngFilters";
import { CellDefaultTooltip } from "app/pages/sales-intelligence/common-components/table-cells";
import type { ICountryObject } from "app/services/CountryService";

import CountryText from "../atoms/CountryText/CountryText";

import { StyledCountryIcon, StyledDetailedResultItem, StyledTooltipContent } from "./styles";

export type CellDetailsByCountryTooltipProps = PropsWithChildren<{
    data: Record<ICountryObject["id"], string | number>;
    formatFn?: (value: string | number) => string;
}>;

const CellDetailsByCountryTooltip = ({
    data,
    formatFn = abbrNumberFilter(),
    children,
}: CellDetailsByCountryTooltipProps) => {
    return (
        <CellDefaultTooltip
            theme="light"
            content={
                <StyledTooltipContent data-automation="details-list-tooltip-content">
                    {Object.entries(data).map(([country, value]) => {
                        const countryCode = Number(country);

                        return (
                            <StyledDetailedResultItem
                                key={countryCode}
                                data-automation="details-list-item"
                            >
                                <Flex gap="8px">
                                    <StyledCountryIcon countryCode={countryCode} />
                                    <CountryText countryCode={countryCode} />
                                </Flex>

                                <Text fontVariant="input2">{formatFn(value)}</Text>
                            </StyledDetailedResultItem>
                        );
                    })}
                </StyledTooltipContent>
            }
        >
            {children}
        </CellDefaultTooltip>
    );
};

export default CellDetailsByCountryTooltip;
